import { DynamicFormV2Palette } from "@mui/material";

export type FormTextButtonComponentTokenType = {
  textColor: string;
  hoverTextColor: string;
};

export const assignTextButtonComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark"
) => {
  const isLightMode = mode === "light";

  return {
    textColor: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
    hoverTextColor: formsPalette.surface.hover.intense,
  } as FormTextButtonComponentTokenType;
};
